<app-modal [isOpen]="isOpen" (close)="onClose()" className="max-w-md mx-4">
  <div class="bg-white dark:bg-gray-900 rounded-2xl overflow-hidden shadow-xl w-full max-w-md mx-auto">

    <div
      class="px-6 py-5 border-b border-gray-100 dark:border-gray-800 flex justify-between items-center bg-gray-50/50 dark:bg-gray-800/30">
      <h3 class="text-lg font-bold text-gray-900 dark:text-white flex items-center gap-2">
        <svg class="w-5 h-5 text-brand-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"></path>
        </svg>
        Crear nueva carpeta
      </h3>
      <button type="button" (click)="onClose()"
        class="text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>




    <form [formGroup]="folderForm" (ngSubmit)="onSubmit()">

      <div class="p-6">
        <!-- ALERT DE ERROR -->
        @if (errorMessage) {
        <div class="mb-4 animate-slideIn">
          <app-alert variant="error" title="Error al crear" [message]="errorMessage" [showLink]="false"></app-alert>
        </div>
        }
        
        <div class="mb-2">
          <label for="folderName" class="mb-1.5 block text-sm font-semibold text-gray-700 dark:text-gray-300">
            Nombre de la carpeta <span class="text-error-500">*</span>
          </label>

          <div class="relative">
            <input type="text" id="folderName" formControlName="name"
              placeholder="Ej. Campañas Navidad, Clientes VIP..." maxlength="150"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 transition-all"
              [class.border-error-500]="isFieldInvalid('name')" [class.border-gray-300]="!isFieldInvalid('name')">
          </div>

          @if (isFieldInvalid('name')) {
          <p class="mt-1.5 text-xs font-medium text-error-500 flex items-center gap-1 animate-fade-in">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Obligatorio. Entre 3 y 150 caracteres.
          </p>
          }
        </div>

        <p class="text-[13px] text-gray-500 dark:text-gray-400 mt-3 font-medium">
          Las carpetas te ayudan a organizar tus listas para encontrarlas más rápido.
        </p>
      </div>

      <div
        class="px-6 py-4 bg-gray-50/50 dark:bg-gray-800/50 border-t border-gray-100 dark:border-gray-800 flex justify-end gap-3">
        <app-button variant="outline" type="button" [disabled]="isSaving" (btnClick)="onClose()">
          Cancelar
        </app-button>

        <app-button type="submit" [disabled]="isSaving">
          @if (isSaving) {
          <div class="flex items-center gap-2">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            <span>Guardando...</span>
          </div>
          } @else {
          Guardar carpeta
          }
        </app-button>
      </div>

    </form>
  </div>
</app-modal>